import * as tvfConditionDetail from '../services/tvfConditionDetail';

export default {
  namespace: 'tvfConditionDetail',

  state: {
    getHandleList: null,
    addRuleManaList: null,
    editRuleManaList: null,
    deleteRuleManaList: null,
  },

  effects: {
    *getHandleList({ payload: { values } }, { call, put }) {
      const { data: response } = yield call(
        tvfConditionDetail.getHandleList,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          getHandleList: response,
        },
      });
    },

    *addRuleManaList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        tvfConditionDetail.addRuleManaList,
        values,
      );
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
      yield put({
        type: 'save',
        payload: {
          addRuleManaList: response,
        },
      });
    },

    *editRuleManaList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        tvfConditionDetail.editRuleManaList,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          editRuleManaList: response,
        },
      });
    },
    *deleteRuleManaList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        tvfConditionDetail.deleteRuleManaList,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          deleteRuleManaList: response,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
